module.exports = __webpack_public_path__ + "img/3-2.96a290f3.png";